
const ThankYou = () => {
   return(
    <div style={{margin: "30px 7%"}}>
      <p>申し込みありがとうございます。</p> 
    </div>   
   ) 
}

export default ThankYou;